<template>
  <AtomButtonLink
    :class="css()"
    :type="AtomButtonLinkTypeEnum.SECONDARY"
    :route="{
      name: 'reports.index',
      params: businessId,
    }"
  >
    <AtomIcon name="reports" :size="21" :class="css('icon')" />
    {{ t("label.reports") }}
  </AtomButtonLink>
</template>

<script>
import { bemBuilder } from "@/v2/util/bem-builder";
import { defineComponent } from "@vue/composition-api";
import {
  AtomButtonLink,
  AtomButtonLinkTypeEnum,
  AtomIcon,
} from "@/v2/new-design-system";
import { t } from "@/i18n";

const css = bemBuilder("order-history-actions");

export default defineComponent({
  name: "OrderHistoryActions",
  components: {
    AtomIcon,
    AtomButtonLink,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      t,
      css,
      AtomButtonLinkTypeEnum,
    };
  },
});
</script>

<style lang="scss" scoped>
.order-history-actions {
  display: flex;
  align-items: center;

  &__icon {
    margin-right: var(--space-7);
  }
}
</style>
